'use strict';

import {SearchFilter} from "./Filter/SearchFilter";
import {BuildingSwitcher} from "./BottomElement/BuildingSwitcher";
import {ResultsViewer} from "./BottomElement/ResultsViewer/ResultsViewer";
import {Buildings, isMobile, projectMode, settingsData, UIRoot} from "../../../../settings";
import {SearchBottomElement} from "./BottomElement/SearchBottomElement";
import {setCSSVar} from "../../../../functions";
import {EventBus} from "../../../interfaces/EventBus";
import { searchGetResults } from '../search';
import {Building} from "../../../building/Building";
import {BackButton} from "./Filter/BackButton";

export class MobileSearch {
	#filter;
	#bottomElement;
	#buildingSwitcher;
	#resultsViewer;
	#backButton;

	constructor() {}

	build() {
		this.#createComponents();
		this.#appendComponents();
		this.#setParametersToComponents();
	}

	update(updateType) {
		if (updateType === 'favorite') {
			EventBus.trigger('favoriteButtonUpdate');
		} else {
			EventBus.trigger('resultsViewerUpdateContent');
		}
	}
	
	filterCards(buildingId) {
		EventBus.trigger('resultsViewerFilterCards', buildingId);
	}

	openFilter() {
		EventBus.trigger('filterShowFilterPopUp');
	}

	fold() {
		EventBus.trigger('searchBottomElementFold');
	}

	unfold() {
		EventBus.trigger('searchBottomElementUnfold');
	}

	setStateTo(state) {
		this.#bottomElement.rootElement.addAttribute('data-state', state);
	}

	get state() {
		return this.#bottomElement.rootElement.getAttribute('data-state');
	}
	
	predict() {
		EventBus.trigger('updateApplyBtnCount', searchGetResults(0,null,false).length);
	}

	show() {
		this.#filter.rootElement.removeClass('hidden');
		this.#bottomElement.rootElement.removeClass('hidden');
	}

	hide() {
		this.#filter.rootElement.addClass('hidden');
		this.#bottomElement.rootElement.addClass('hidden');
	}

	focusOnApartment(id) {
		EventBus.trigger('resultsViewerSlideToApartment', id);
	}

	// focusOnActiveCard() {
	// 	const activeCard = this.#bottomElement.rootElement.DOMElement.querySelector('.active-slide');
	// 	if (!activeCard)
	// 		return;
	// 	const activeCardId = activeCard && activeCard.querySelector('[data-engineId]').getAttribute('data-engineId');
	// 	EventBus.trigger('resultsViewerSlideToApartment', activeCardId)
	// }

	#createComponents() {
		this.#filter = new SearchFilter();
		this.#bottomElement = new SearchBottomElement();
		this.#buildingSwitcher = /*!config.features.privateHouseMode && *//*!projectMode.LiteMode.modeIs('picture') &&*/ new BuildingSwitcher();
		this.#resultsViewer = new ResultsViewer();
		this.#backButton = new BackButton(this.#filter.rootElement);
	}

	#appendComponents() {
		this.#filter.rootElement.appendTo(UIRoot);
		this.#bottomElement.rootElement.appendTo(UIRoot);
		this.#resultsViewer.rootElement.appendTo(this.#bottomElement.rootElement.DOMElement);
		this.#buildingSwitcher?.rootElement?.appendTo(this.#bottomElement.rootElement.DOMElement);
	}

	#setParametersToComponents() {
		if (this.#buildingSwitcher)
			this.#buildingSwitcher?.setActiveBuildingName();
		EventBus.trigger('resultsViewerToggleContent');
		EventBus.trigger('mobileSearchResultsAmountUpdate');
		setCSSVar('--mobile-search-filter-height', this.#filter.rootElement.DOMElement.getBoundingClientRect().height + 'px');
	}

	getApartmentId() {
		const isPictureMode = projectMode.LiteMode.modeIs('picture');
		const isPrivateHouseMode = config.features?.privateHouseMode;
		let availableAptsOfBuilding;
		if (isPictureMode || isPrivateHouseMode) {
			availableAptsOfBuilding = settingsData.searchResult.filter(apt => apt.status === 'Available');
		} else {
			availableAptsOfBuilding = settingsData.searchResult
				.filter(apt => apt.buildingEngineId === Buildings.getActiveBuilding().name)
				.filter(apt => apt.status === 'Available');

			if (!availableAptsOfBuilding || !availableAptsOfBuilding.length) {
				availableAptsOfBuilding = settingsData.searchResult
					.filter(apt => apt.status === 'Available');
			}
		}
		if (!availableAptsOfBuilding || !availableAptsOfBuilding.length)
			return null;

		return availableAptsOfBuilding[0].engineId;
	}

	remove() {
		this.#filter?.remove();
		this.#bottomElement?.remove();
		this.#buildingSwitcher && this.#buildingSwitcher?.remove();
		this.#resultsViewer?.remove();
		this.#backButton?.remove();

		this.#filter = null;
		this.#bottomElement = null;
		this.#buildingSwitcher = null;
		this.#resultsViewer = null;
		this.#backButton = null;
	}
}
